export const FETCH_SUBSCRIPTIONS = 'FETCH_SUBSCRIPTIONS';
export const FETCH_SUBSCRIPTIONS_OK = 'FETCH_SUBSCRIPTIONS_OK';
export const FETCH_SUBSCRIPTIONS_FAIL = 'FETCH_SUBSCRIPTIONS_FAIL';
export const SUBSCRIBE = 'SUBSCRIBE';
export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const CANCEL_USER_SUBSCRIPTION = 'CANCEL_USER_SUBSCRIPTION';
export const REACTIVATE_USER_SUBSCRIPTION = 'REACTIVATE_USER_SUBSCRIPTION';
export const PAY_MEMBERSHIP = 'PAY_MEMBERSHIP';
export const PAY_MEMBERSHIP_OK = 'PAY_MEMBERSHIP_OK';
export const PAY_MEMBERSHIP_FAILED = 'PAY_MEMBERSHIP_FAILED';
export const SET_SUBSCRIPTION_FLOW = 'SET_SUBSCRIPTION_FLOW';
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION';
export const NUMBERS_OF_PEOPLE = 'NUMBERS_OF_PEOPLE';
export const CHECK_SUBSCRIPTION_PIN = 'CHECK_SUBSCRIPTION_PIN';
export const INVITE_USER = 'INVITE_USER';
export const RESEND_SUBSCRIPTION_INVITE_EMAIL = 'RESEND_SUBSCRIPTION_INVITE_EMAIL';
export const CREATE_SUBSCRIPTION_NATIVE = 'CREATE_SUBSCRIPTION_NATIVE';
